import { defineComponent as f, ref as g, computed as u } from "vue";
import { DropdownMenuTypes as i, DropdownMenuItemTypes as I } from "./index3.js";
import { DropdownMenuItem as A, DropdownMenuItemTypes as B, DropdownMenuTypes as q } from "./index3.js";
import { generateRandomId as l } from "./index7.js";
const x = f({
  name: "dropdown-menu",
  props: {
    menuItems: {
      type: Array,
      default: () => []
    },
    hasArrowIcon: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: i.ExpandOnHover
    },
    showItems: {
      type: Boolean,
      default: void 0
    }
  },
  mounted() {
    document.body.addEventListener("click", this.detectClickOutside);
  },
  setup(o, { emit: c }) {
    const p = I, y = i, d = g(!1), n = u({
      get: () => o.showItems ?? d.value,
      set: (t) => {
        c("update:showItems", t), d.value = t;
      }
    });
    n.value = o.type === i.ExpandOnHover;
    const a = l(), r = l(), h = u(() => o.menuItems.filter((t) => t.isVisible)), s = u(() => o.type === i.ExpandOnClick);
    return {
      menuItemTypes: p,
      menuTypes: y,
      showMenuItems: n,
      visibleMenuItems: h,
      isExpandOnClickType: s,
      toggleMenuItemsVisibility: function(t) {
        s.value && (document.getElementById(r)?.contains(t.target) || (n.value = !n.value));
      },
      hideMenuItemsIfExpandOnClickType: function() {
        s.value && (n.value = !1);
      },
      uniqueId: a,
      listWrapperId: r,
      detectClickOutside: function(t) {
        const e = document.getElementById(a);
        e !== t.target && e !== null && !e.contains(t.target) && (n.value = !1);
      },
      enter: function(t) {
        const e = getComputedStyle(t).width;
        t.style.width = e, t.style.position = "absolute", t.style.visibility = "hidden", t.style.height = "auto";
        const m = getComputedStyle(t).height;
        t.style.width = "", t.style.position = "", t.style.visibility = "", t.style.height = "0", getComputedStyle(t).height, requestAnimationFrame(() => {
          t.style.height = m;
        });
      },
      afterEnter: function(t) {
        t.style.height = "auto";
      },
      leave: function(t) {
        const e = getComputedStyle(t).height;
        t.style.height = e, getComputedStyle(t).height, requestAnimationFrame(() => {
          t.style.height = "0";
        });
      }
    };
  }
});
export {
  A as DropdownMenuItem,
  B as DropdownMenuItemTypes,
  q as DropdownMenuTypes,
  x as default
};
//# sourceMappingURL=index4.js.map
